import Pqp from "../../../3x1010/Pqp";
import Assets from "../Assets";

export default class Sounder {

  static play(id, callback = null, loop = false, oneInstance = false) {
    let sound = Sounder._getSoundById(id);
    if (oneInstance) {
      Sounder._removeAllAudioInstances(id);
    }
    let audio = new Audio();
    audio.src = sound.src;
    
    audio.volume = Sounder.volume;
    audio.muted = false;
    audio.play();
    
    let instance = { guid: Pqp.newGuid(), id: id, audio: audio, loop: loop, oneInstance: oneInstance };
    audio.addEventListener("ended", Sounder._audioEnded.bind(Sounder, instance, callback));
    Sounder._instances.push(instance);
  }
  static getDuration(id) {
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].id === id) {
        return Sounder._instances[x].audio.duration;
      }
    }
    return null

  }

  static seek(id,time) {
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].id === id) {
        Sounder._instances[x].audio.currentTime = time;
      }
    }
  }

  static stop(id) {
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].id === id) {
        Sounder._instances[x].audio.pause();
        Sounder._removeAudioInstance(Sounder._instances[x]);
      }
    }
  }

  static pauseAll() {
    for (let x = 0; x < Sounder._instances.length; x++) {
       Sounder._instances[x].audio.pause();
    }
  }

  static resumeAll() {
    for (let x = 0; x < Sounder._instances.length; x++) {
       Sounder._instances[x].audio.play();
    }
  }

  static pause(id) {
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].id === id) {
        Sounder._instances[x].audio.pause();
      }
    }
  }

  static resume(id) {
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].id === id) {
        Sounder._instances[x].audio.play();
      }
    }

  }

  static setAllVolume(n) {
    if (n > 1) {
      n = 1;
    }
    if (n < 0) {
      n = 0;
    }
    for (let x = 0; x < Sounder._instances.length; x++) {
      Sounder._instances[x].audio.volume = n;
    }
    Sounder.volume = n;
  }

  static _audioEnded(instance, callback) {
    //alert(instance)
    Sounder._dispatch(callback, Sounder.EVENT_SOUND_ENDED, instance)
    Sounder._removeAudioInstance(instance);
    if (instance.loop) {
      Sounder.play(instance.id,callback, true);
    }
    //console.log(Sounder._instances)

  }

  static _dispatch(callback, type, data = null) {
    if (callback) {
      callback.call(null, { type: type, data: data });
    }
  }



  static _removeAllAudioInstances(id) {
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].id === id) {
        Sounder._instances[x].audio.pause();
        Sounder._removeAudioInstance(Sounder._instances[x]);
      }
    }
  }

  static _removeAudioInstance(instance) {
    let tmp = new Array();
    for (let x = 0; x < Sounder._instances.length; x++) {
      if (Sounder._instances[x].guid !== instance.guid) {
        tmp.push(Sounder._instances[x]);
      }
    }
    Sounder._instances = tmp;
  }

  static _getSoundById(idSound) {
    Sounder._sounds = Assets.getSounds();
    return Sounder._sounds.find(({ id }) => id === idSound);
  }

}

Sounder._sounds = [];
Sounder._current = 0;
Sounder._inited = false;
Sounder._instances = [];
Sounder.volume = 1;

Sounder.EVENT_SOUND_ENDED = "eventSoundEnded";